module.exports = __webpack_public_path__ + "img/orange_081.a1c53107.png";